import(/* webpackMode: "eager", webpackExports: ["BacktestingFeatureView"] */ "/vercel/path0/apps/web/src/sections/features/backtesting/view/page.tsx");
